<div class="card mb-2">
  <div
    class="card-header text-white"
    [ngClass]="{
      'bg-sel': centerDataFiltered.sessions.length > 0 && !isFilterEnabled,
      'bg-success': centerDataFiltered.sessions.length > 0 && isFilterEnabled,
      'bg-danger': centerDataFiltered.sessions.length == 0
    }"
  >
    <div class="row no-gutters">
      <div class="col-11">{{ centerDataFiltered.name }}</div>
      <div class="col-1">
        <a
          class=""
          (click)="
            clickBellIndi(centerDataFiltered.center_id, centerDataFiltered.name)
          "
          ><i class="icon ion-android-notifications mx-1"></i
        ></a>
      </div>
    </div>
  </div>
  <div class="card-body">
    <h6 class="card-title font-09 row no-gutters">
      {{ centerDataFiltered.block_name
      }}<span class="ml-auto badge badge-dark px-2">{{
        centerDataFiltered.fee_type
      }}</span>
    </h6>
    <table
      id="address-table"
      class="table table-borderless table-sm text-small"
    >
      <tbody>
        <tr>
          <td>{{ centerDataFiltered.address }}</td>
        </tr>
        <tr>
          <td>
            {{ centerDataFiltered.district_name }},
            {{ centerDataFiltered.state_name }},
            {{ centerDataFiltered.pincode }}
          </td>
        </tr>
      </tbody>
    </table>
    <h6 *ngIf="centerDataFiltered.sessions.length" class="card-text font-09">
      Slot Availiblity
    </h6>
    <table
      *ngIf="centerDataFiltered.sessions.length"
      class="table table-bordered"
      id="slot-table"
    >
      <thead>
        <tr>
          <th>Date</th>
          <th>Dose 1</th>
          <th>Dose 2</th>
          <th>Min Age</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of centerDataFiltered.sessions">
          <td>{{ data.date }}</td>
          <td>{{ data.available_capacity_dose1 }}</td>
          <td>{{ data.available_capacity_dose2 }}</td>
          <td>{{ data.min_age_limit }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="text-danger text-center mt-2"
      *ngIf="centerDataFiltered.sessions.length < 1"
    >
      No Slots Available
    </div>
  </div>
</div>
